const DETAILS_KEY = 'viewedProductDetails';

function escapeHtml(value = '') {
  return String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
}

function render(section) {
  if (!section || section.dataset.rendered === 'true') return;
  let items = [];
  try { items = JSON.parse(localStorage.getItem(DETAILS_KEY) || '[]'); } catch (_) {}
  const currentId = String(section.dataset.currentProductId || '');
  items = items.filter((item) => item && String(item.id) !== currentId && item.url && item.title).slice(0, 4);
  if (!items.length) return;
  const grid = section.querySelector('[data-hadeva-recent-grid]');
  if (!grid) return;
  grid.innerHTML = items.map((item) => `
    <article class="hadeva-recent-card">
      <a href="${escapeHtml(item.url)}">
        <span class="hadeva-recent-card__media">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" width="480" height="600">` : ''}</span>
        <span class="hadeva-recent-card__copy"><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.price)}</small><em>View product →</em></span>
      </a>
    </article>`).join('');
  section.hidden = false;
  section.dataset.rendered = 'true';
}

document.querySelectorAll('[data-hadeva-recently-viewed]').forEach(render);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-hadeva-recently-viewed]').forEach(render));
